var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20.571,
    viewBox: "0 0 18 20.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bell",
    "data-name": "Icon awesome-bell",
    d: "M9,20.571A2.571,2.571,0,0,0,11.57,18H6.43A2.571,2.571,0,0,0,9,20.571Zm8.654-6.015c-.776-.834-2.229-2.089-2.229-6.2a6.345,6.345,0,0,0-5.14-6.234V1.286a1.285,1.285,0,1,0-2.57,0v.837a6.345,6.345,0,0,0-5.14,6.234c0,4.11-1.452,5.365-2.229,6.2A1.255,1.255,0,0,0,0,15.429a1.287,1.287,0,0,0,1.29,1.286H16.71A1.287,1.287,0,0,0,18,15.429a1.255,1.255,0,0,0-.346-.872Z",
    transform: "translate(0)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeBell);
export default __webpack_public_path__ + "static/media/Icon awesome-bell.ffa82eda46ad7de25dcd6091afd1a0e9.svg";
export { ForwardRef as ReactComponent };